<div class="mainDiv">
    <div class="newOrder">
        <div style="width: 90%;text-align: center;">
            How can we help ?
        </div>

        <div style="width: 10%; ">
            <mat-icon (click)="hide()" class="address_span" style="font-size: 22px !important;overflow: inherit;background: none;width: 100%; padding-top: 2px;">highlight_off
            </mat-icon>
        </div>
    </div>


</div>
